var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('hr',{staticClass:"divider",class:_vm.customClasses,style:(_vm.cssVars)})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib?{}!./scripts/vue/PageDivider.vue?vue&type=template&id=f23130be&scoped=true&
// module id = 127
// module chunks = 0